import theme from '@styles/theme';
import { BASE_PATH } from '@config/index';
export default {
  googleMap: {
    background: theme.rawColors.lightGrey300,
    width: '100%',
    height: '600px',
    '.map-info': {
      display: 'inline-block',
      padding: '10px',
      p: {
        margin: '10px 0'
      },
      ':before': {
        content: '""',
        backgroundImage: `url(${BASE_PATH}/img/logo.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        float: 'left',
        width: '90px',
        minHeight: '110px',
        margin: 'auto 20px auto 0'
      }
    }
  }
};